export const GET_BADGE_LIST_REQUEST = "GET_BADGE_LIST_REQUEST";
export const GET_BADGE_LIST_SUCCESS = "GET_BADGE_LIST_SUCCESS";
export const GET_BADGE_LIST_FAIL = "GET_BADGE_LIST_FAIL";

export const CREATE_BADGE_REQUEST = "CREATE_BADGE_REQUEST";
export const CREATE_BADGE_SUCCESS = "CREATE_BADGE_SUCCESS";
export const CREATE_BADGE_FAIL = "CREATE_BADGE_FAIL";

export const UPDATE_BADGE_REQUEST = "UPDATE_BADGE_REQUEST";
export const UPDATE_BADGE_SUCCESS = "UPDATE_BADGE_SUCCESS";
export const UPDATE_BADGE_FAIL = "UPDATE_BADGE_FAIL";

export const DELETE_BADGE_REQUEST = "DELETE_BADGE_REQUEST";
export const DELETE_BADGE_SUCCESS = "DELETE_BADGE_SUCCESS";
export const DELETE_BADGE_FAIL = "DELETE_BADGE_FAIL";

export const GET_CERTIFICATE_LIST_REQUEST = "GET_CERTIFICATE_LIST_REQUEST";
export const GET_CERTIFICATE_LIST_SUCCESS = "GET_CERTIFICATE_LIST_SUCCESS";
export const GET_CERTIFICATE_LIST_FAIL = "GET_CERTIFICATE_LIST_FAIL";

export const CREATE_CERTIFICATE_REQUEST = "CREATE_CERTIFICATE_REQUEST";
export const CREATE_CERTIFICATE_SUCCESS = "CREATE_CERTIFICATE_SUCCESS";
export const CREATE_CERTIFICATE_FAIL = "CREATE_CERTIFICATE_FAIL";

export const UPDATE_CERTIFICATE_REQUEST = "UPDATE_CERTIFICATE_REQUEST";
export const UPDATE_CERTIFICATE_SUCCESS = "UPDATE_CERTIFICATE_SUCCESS";
export const UPDATE_CERTIFICATE_FAIL = "UPDATE_CERTIFICATE_FAIL";

export const DELETE_CERTIFICATE_REQUEST = "DELETE_CERTIFICATE_REQUEST";
export const DELETE_CERTIFICATE_SUCCESS = "DELETE_CERTIFICATE_SUCCESS";
export const DELETE_CERTIFICATE_FAIL = "DELETE_CERTIFICATE_FAIL";

export const UPLOAD_CERTIFICATE_TEMPLATE_REQUEST =
  "UPLOAD_CERTIFICATE_TEMPLATE_REQUEST";
export const UPLOAD_CERTIFICATE_TEMPLATE_SUCCESS =
  "UPLOAD_CERTIFICATE_TEMPLATE_SUCCESS";
export const UPLOAD_CERTIFICATE_TEMPLATE_FAIL =
  "UPLOAD_CERTIFICATE_TEMPLATE_FAIL";

export const GET_CERTIFICATE_CRITERIA_LIST_REQUEST =
  "GET_CERTIFICATE_CRITERIA_LIST_REQUEST";
export const GET_CERTIFICATE_CRITERIA_LIST_SUCCESS =
  "GET_CERTIFICATE_CRITERIA_LIST_SUCCESS";
export const GET_CERTIFICATE_CRITERIA_LIST_FAIL =
  "GET_CERTIFICATE_CRITERIA_LIST_FAIL";

export const CREATE_CERTIFICATE_CRITERIA_REQUEST =
  "CREATE_CERTIFICATE_CRITERIA_REQUEST";
export const CREATE_CERTIFICATE_CRITERIA_SUCCESS =
  "CREATE_CERTIFICATE_CRITERIA_SUCCESS";
export const CREATE_CERTIFICATE_CRITERIA_FAIL =
  "CREATE_CERTIFICATE_CRITERIA_FAIL";

export const UPDATE_CERTIFICATE_CRITERIA_REQUEST =
  "UPDATE_CERTIFICATE_CRITERIA_REQUEST";
export const UPDATE_CERTIFICATE_CRITERIA_SUCCESS =
  "UPDATE_CERTIFICATE_CRITERIA_SUCCESS";
export const UPDATE_CERTIFICATE_CRITERIA_FAIL =
  "UPDATE_CERTIFICATE_CRITERIA_FAIL";

export const DELETE_CERTIFICATE_CRITERIA_REQUEST =
  "DELETE_CERTIFICATE_CRITERIA_REQUEST";
export const DELETE_CERTIFICATE_CRITERIA_SUCCESS =
  "DELETE_CERTIFICATE_CRITERIA_SUCCESS";
export const DELETE_CERTIFICATE_CRITERIA_FAIL =
  "DELETE_CERTIFICATE_CRITERIA_FAIL";

export const GET_CERTIFICATE_CRITERIA_BY_ID_REQUEST =
  "GET_CERTIFICATE_CRITERIA_BY_ID_REQUEST";
export const GET_CERTIFICATE_CRITERIA_BY_ID_SUCCESS =
  "GET_CERTIFICATE_CRITERIA_BY_ID_SUCCESS";
export const GET_CERTIFICATE_CRITERIA_BY_ID_FAIL =
  "GET_CERTIFICATE_CRITERIA_BY_ID_FAIL";
